import { React, useState, useEffect } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import Select from 'react-select';
import { Link } from 'react-router-dom';
import LeaseApiService from '../../services/apiService';
import { IoSearch } from "react-icons/io5";
import WindowedSelect from 'react-windowed-select';
import { ClipLoader } from 'react-spinners';
import { FaSave } from "react-icons/fa";
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL
const Details = ({ detailsFormData, setDetailsFormData, detailsProperty, detailsLeaseNos }) => {
    const apiService = new LeaseApiService();
    const [unitRent, setUnitRent] = useState(true);
    const [SecondaryTab, setSecondaryTab] = useState(true);
    const [unitList, setUnitList] = useState([])
    const [userdata, setUserData] = useState()
    const [loading, setloader] = useState(false)
    const [emailModal, setEmailModal] = useState(false);
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);
    const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

    const StatusFilter = [
        { value: 'On Notice', label: 'On Notice' },
        { value: 'Terminated', label: 'Terminated' },
    ];

    const handleClearFilters = () => {
        setDetailsFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
            Status: [{ label: 'Select', value: '' }],
        });
        setloader(false)
        setUserData(null)
    }
    const handlePropertyChange = async (selectedOption) => {
        setDetailsFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
            Status: [{ label: 'Select', value: '' }],
        });
        const params = new URLSearchParams();
        params.append('DropdownFor', 'TeminationStatusUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value?.value);
        const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items)
        setDetailsFormData({
            ...detailsFormData,
            Proprty: selectedOption,
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
            Status: [{ label: 'Select', value: '' }],
        });

    }
    const handleUitNo = async (selectedOption) => {
        setDetailsFormData({
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
        let selectedLease = detailsLeaseNos?.find((comp) => comp.value === selectedOption?.value?.value)
        setDetailsFormData({
            ...detailsFormData,
            unitNo: selectedOption,
            leaseNo: { label: selectedLease?.value, value: selectedLease },
        });
    }
    const handleLeaseChange = async (selectedOption) => {

        const duductoinParam = new URLSearchParams();
        duductoinParam.append('Action', 'LTStatusGetTenantDetails');
        duductoinParam.append('LeaseNo', selectedOption?.label);
        const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
        let res = deductionRes?.data?.result?.data
        setDetailsFormData({
            ...detailsFormData,
            leaseNo: selectedOption,
            Proprty: [{ label: res?.Property_Name, value: { text: res?.Property_Name, value: res?.Property_Id } }],
            unitNo: [{ label: res?.Unit_No, value: res?.Unit_No }],
        });
    }
    const handleSearch = async () => {
        try {
            const duductoinParam = new URLSearchParams();
            duductoinParam.append('Action', 'LTStatusGetTenantDetails');
            duductoinParam.append('LeaseNo', detailsFormData?.leaseNo?.label);
            const deductionRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${duductoinParam.toString()}`);
            setUserData(deductionRes?.data?.result?.data)

        } catch (error) {
            console.error('Error fetching  data:', error);
        }
    }
    const handleStatusFilter = (selectedOption) => {
        setDetailsFormData({ ...detailsFormData, Status: selectedOption });
    }
    const handleSave = async () => {
        try {
            setloader(true)
            if (!detailsFormData?.Proprty?.value?.value) {
                toast?.warning("Please Select Property")
                setloader(false)
                return
            } else if (!detailsFormData?.unitNo?.value?.value) {
                toast?.warning("Please Select Unit No")
                setloader(false)
                return
            } else if (!detailsFormData?.leaseNo?.value?.value) {
                toast?.warning("Please Select lease No")
                setloader(false)
                return
            } else if (!userdata?.Cust1_Name) {
                toast?.warning("Please Set Tanent Name")
                setloader(false)
                return
            } else if (!detailsFormData?.Status?.value) {
                toast?.warning("Please Select Status")
                setloader(false)
                return
            } else if (detailsFormData?.leaseNo?.label != userdata?.Lease_No) {
                toast?.warning("Please Select the Lease No and try again")
                setloader(false)
                return
            }

            const params = new URLSearchParams();
            params.append('Action', 'LTStatusCheckDate');
            params.append('LeaseNo', userdata?.Lease_No);
            const res = await apiService.getApiParamater('TERMINATION_COMMON', `?${params.toString()}`);
            let resData = res?.data?.result?.data

            if (resData?.Cnt > 0) {
                onOpenModal()
            } else if (resData?.Cnt === 0 || null) {
                const snfparams = new URLSearchParams();
                snfparams.append('Action', 'LTStatuscheckOSN');
                snfparams.append('LeaseNo', userdata?.Lease_No);
                const rScondRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${snfparams.toString()}`);
                let sndResData = rScondRes?.data?.result?.data
                if (sndResData?.Cnt > 0) {
                    toast.warning("OSN Package\\ INTERNET Not Updated?")
                } else if (sndResData?.Cnt === 0 || null) {
                    handleSaveData(true)
                }
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handleSaveData = async (yes) => {
        try {
            if (yes) {
                datasave()
            } else if (!yes) {
                const snfparams = new URLSearchParams();
                snfparams.append('Action', 'LTStatuscheckOSN');
                snfparams.append('LeaseNo', userdata?.Lease_No);
                const rScondRes = await apiService.getApiParamater('TERMINATION_COMMON', `?${snfparams.toString()}`);
                let sndResData = rScondRes?.data?.result?.data
                if (sndResData?.Cnt > 0) {
                    toast.warning("OSN Package\\ INTERNET Not Updated?")
                } else if (sndResData?.Cnt === 0 || null) {
                    datasave()
                }
            }
        } catch (error) {
            console.error('Error Save Data', error);
            setloader(false);
        } finally {
            setloader(false);
        }
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS
                form.target = "ReportPopup";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "LeaseNo", value: detailsFormData?.leaseNo?.label },
                    { name: "reportName", value: 'LTER' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const datasave = async () => {
        let body = {
            propertyNo: detailsFormData?.Proprty?.value?.value,
            unitNo: detailsFormData?.unitNo?.label,
            leaseNo: detailsFormData?.leaseNo?.label,
            status: detailsFormData?.Status?.label
        }
        const postRes = await apiService.post('UPDATE_TERMINATION_STATUS', body);
        if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
            toast.success(postRes?.data?.message);
            handlePrint()
            let rowData = postRes?.data?.result
            handlePrint(rowData)
            handleClearFilters()
            setloader(false);
            onCloseModal()
        } else {
            toast.warning(`${postRes?.data?.message}`);
            setloader(false);
            onCloseModal()
        }
    }

    const openStatementPopup = (rowData) => {
        if (detailsFormData?.leaseNo) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup3",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup3";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "RecordId", value: "" },
                    { name: "LeaseNo", value: detailsFormData?.leaseNo?.label },
                    { name: "ReceiptNo", value: "" },
                    { name: "reportName", value: "LSESTMT" },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }

    const handleTerminationPrint = (rowData) => {
        if (detailsFormData?.leaseNo) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }

            // Open both reports simultaneously
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "LeaseNo", value: detailsFormData?.leaseNo?.label },
                    { name: "reportName", value: 'LTER' },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className=' mt-3'>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setUnitRent(!unitRent)}>
                    <div className='param-label pt-1'>Search</div>
                </div>
                <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group grid-contain ">
                            <div className='d-flex'>
                                <Select
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={detailsFormData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={detailsProperty?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='d-flex'>
                                <Select
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={detailsFormData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='d-flex'>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    options={
                                        detailsLeaseNos
                                            ?.slice(0, 8000)
                                            .map(rec => ({ value: rec, label: rec?.value }))
                                    }
                                    value={detailsFormData.leaseNo}
                                    onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <div className='mainbtnGry flex-end gap-2 w-50' onClick={handleSearch}>
                                    <IoSearch color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                {loading === true ?
                                    <div className='mainbtn flex-end gap-2 w-50'>
                                        <ClipLoader color="#ffffff" className='mt-1' size={25} />
                                    </div>
                                    :
                                    <div className='mainbtn flex-end gap-2 w-50' onClick={handleSave}>
                                        <FaSave color='#fff' className='center mt-1 mx-2' />
                                        <div className='center'>Save</div>
                                    </div>
                                }
                                <div className='mainbtnRed flex-end gap-2 w-50' onClick={handleClearFilters}>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section my-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setSecondaryTab(!SecondaryTab)}>
                    <div className='param-label pt-1'>Update</div>
                </div>
                <div className={`slide-content ${SecondaryTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${SecondaryTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                            {/* PropertNo */}
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Status</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                    value={detailsFormData.Status}
                                    options={StatusFilter}
                                    onChange={handleStatusFilter}
                                />
                            </div>
                            <div className='d-flex gap-3'>
                                <div className='d-flex'>
                                    {!userdata?.Lease_No ?
                                        <div>View Termination Details</div> :
                                        <Link onClick={handleTerminationPrint}>View Termination Details</Link>
                                    }
                                </div>
                                <div className='d-flex'>
                                    {!userdata?.Lease_No ?
                                        <div>View Lease Statement</div> :
                                        <Link onClick={openStatementPopup}>View Lease Statement</Link>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className=''>
                            <div className='d-flex gap-5 mt-4'>
                                <h5>Lease No  :  </h5>
                                <h5>{userdata?.Lease_No || "---"}</h5>
                            </div>
                            <div className='d-flex gap-5 mt-4'>
                                <h5>Tanent Name  :  </h5>
                                <h5>{userdata?.Cust1_Name || "---"}</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal size="md"
                show={emailModal} onHide={() => setEmailModal(false)}
                backdrop="static"
                contentLabel='Email Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Vacating date is different</Modal.Title>
                </Modal.Header>
                <Modal.Body> Are you sure to continue (Yes/No)?</Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>No</button>
                    <button className='mainbtnRed' onClick={() => handleSaveData(false)}>Yes</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Details;